var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
const StyledTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className } })));
})(({ theme }) => ({
    padding: theme.palette.tooltip.padding,
    '& .MuiTooltip-arrow': {
        color: theme.palette.tooltip.background.default
    },
    '& .MuiTooltip-tooltip': {
        backgroundColor: theme.palette.tooltip.background.default,
        color: theme.palette.tooltip.text,
        border: `${theme.palette.tooltip.border.width} solid ${theme.palette.tooltip.border.default}`,
        fontFamily: theme.palette.tooltip.font.family,
        fontSize: theme.palette.tooltip.font.size,
        lineHeight: theme.palette.tooltip.font.lineHeight,
        fontWeight: theme.palette.tooltip.font.weight,
        letterSpacing: theme.palette.tooltip.font.letterSpacing
    }
}));
const BDSTooltip = React.forwardRef((_a, ref) => {
    var { arrow = true, children } = _a, props = __rest(_a, ["arrow", "children"]);
    return (React.createElement(StyledTooltip, Object.assign({ arrow: arrow, ref: ref }, props), children));
});
BDSTooltip.displayName = 'Tooltip';
export default BDSTooltip;
//# sourceMappingURL=Tooltip.js.map